import { WhatsAppAuthMode, WhatsAppConnectionAttemptSnapshot } from '../../../api/whatsapp';

export const WHATSAPP_PHONE_PATTERN = /^\+[1-9]\d{6,14}$/;

export interface ProfileWhatsAppAccountCreateState {
  submitting: boolean;
  connecting: boolean;
  authMode: WhatsAppAuthMode;
  attempt: WhatsAppConnectionAttemptSnapshot | null;
  qrImage: string | null;
  targetPhoneNumber: string | null;
  errorMessage: string;
  // Pending values waiting for the confirm-phone modal acknowledgement.
  // null means the modal is hidden.
  pendingConfirm: BindAccountFormValues | null;
}

export interface BindAccountFormValues {
  phone_number: string;
  alias?: string;
  set_default: boolean;
}
